module.exports = __webpack_public_path__ + "img/myposition_am_토마스 뮐러.fd8aaef1.png";